import React, { useRef } from 'react'
import HPIFields from '../../../../SOAP/Components/HPIFields'
import TextEditor from '../../../../../../../../../../../shared-components/TextEditor'

const HPI = ({ widgetUtilities, ...props }) => {
    const quillHPIRef = useRef(null);

    const {
        initialDataPatientName, initialDataAge, initialDataDOB, initialDataAddress, initialDataMobileNumber, initialDataEmail,
        subjectiveData, setSubjectiveData,
        setSaveHPIData
    } = widgetUtilities;

    const handleChangeFreeText = (value, type) => {
        if (type === 'HistoryofPresentIllnessNotes') {
            setSubjectiveData(prev => ({
                ...prev, "HistoryofPresentIllnessNotes": value,
            }));
        }
    }
    return (
    <div className="d-flex gap-10">
        <div className="ar-form-counter flex-center">
            <p className='text text-black'>{props?.itemCount}</p>
        </div>
        <div className="d-flex flex-column gap-6 w-100"
    //   id={scrollNavIDs.refSUBJECTIVEHPI} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refSUBJECTIVEHPI)} onClick={() => handleActiveItem(scrollNavIDs.refSUBJECTIVEHPI)}
    >
        <p className="heading fs-13"
        //  onClick={() => handleItemsExpanded('HPI')}
        >History of Present Illness</p>
        {/* {!itemsCollapsed?.['HPI'] &&
            ( */}
        <div className='d-flex flex-column gap-1 observation-content'>
            {/* {["Fields", "Both"].includes(defaultSelectedItems.historyofPresentIllnessType) ? */}
            <HPIFields setSaveHPIData={setSaveHPIData} hpiData={subjectiveData.HistoryOfPresentIllness} setSubjectiveData={setSubjectiveData} />
            {/* : <></>} */}
            {/* {["FreeText", "Both"].includes(defaultSelectedItems.historyofPresentIllnessType) ? */}
            <div className='d-flex flex-column gap-6'>
                {/* {["Both"].includes(defaultSelectedItems.historyofPresentIllnessType) &&  */}
                <p className="heading fs-13 cursor-pointer user-select-none w-max-content">HPI Notes</p>
                {/* } */}
                <div className="">
                    <TextEditor
                        quillRef={quillHPIRef}
                        value={subjectiveData.HistoryofPresentIllnessNotes}
                        setValue={(value) => handleChangeFreeText(value, 'HistoryofPresentIllnessNotes')}
                        placeholderReplacement={true}
                        customDropDown={{
                            'active': true,
                            'options': [
                                { value: initialDataPatientName, display: '$Name', },
                                { value: initialDataAge, display: '$Age', },
                                { value: initialDataDOB, display: '$DOB', },
                                { value: initialDataAddress, display: '$Address', },
                                { value: initialDataMobileNumber, display: '$Phone', },
                                { value: initialDataEmail, display: '$Email', },
                            ]
                        }}
                        placeholder={"Detail HPI Notes..."}
                    />
                </div>
            </div>
            {/* : <></>} */}
        </div>
        {/* )} */}
    </div>
    </div>
    )
}

export default HPI